export class DtcUserValidationError {
  messages;
  constructor(messages: string[]) {
    this.messages = messages;
  }
}
